module.exports = __webpack_public_path__ + "static/media/logo-color.10cb3db0.png";